import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { LanguageContext } from '../LanguageContext';
import OfferCard from '../components/OfferCard';

import imgOmraFévrier2025 from '../img/tour-thumb04.jpg';
import imgOmra1 from '../img/off1.jpg'; 
import imgOmra2 from '../img/off2.jpg'; 
import imgOmra3 from '../img/off3.jpg'; 
import imgOmra4 from '../img/off4.jpg'; 
import imgOmra5 from '../img/off5.jpeg'; 

function Omra2025() {
  const { language } = useContext(LanguageContext);

  const content = {
    fr: {
      pageTitle: "NOS OMRAS",
      description1: "Nous vous offrons des tarifs compétitifs pour chaque pèlerinage, tout en veillant à maintenir un niveau de service élevé et des standards de qualité.",
      description2: "Ces tarifs incluent une gamme complète de services, tels que l'obtention du visa, le service d'accompagnement avant le séjour, les vols aller-retour, l'hébergement à proximité du Haram, l'encadrement par un guide tout au long du séjour, les transports internes, les visites des lieux saints, ainsi que l'accompagnement spirituel par des guides religieux locaux.",
      description3: "Les tarifs varient en fonction des dates.",
      offersTitle: "Nos Offres Omra",
      soonTag: "PROCHAINEMENT"
    },
    ar: {
      pageTitle: "عروض العمرة",
      description1: "نقدم لكم أسعارًا تنافسية لكل رحلة حج مع الحفاظ على مستوى عالٍ من الخدمة ومعايير الجودة.",
      description2: "تشمل هذه الأسعار مجموعة كاملة من الخدمات مثل الحصول على التأشيرة، وخدمة المرافقة قبل الإقامة، ورحلات الطيران ذهابًا وإيابًا، والإقامة بالقرب من الحرم، والإشراف من قبل مرشد طوال فترة الإقامة، وزيارة الأماكن المقدسة، بالإضافة إلى الإرشاد الروحي من قبل مرشدين دينيين محليين.",
      description3: "تختلف الأسعار حسب التواريخ.",
      offersTitle: "عروضنا للعمرة",
      soonTag: "قريبًا"
    }
  };

  const textAnimation = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  };

  const cardAnimation = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: { 
      opacity: 1, 
      scale: 1,
      transition: { 
        duration: 0.5,
        ease: "easeOut"
      }
    },
    hover: {
      y: -5,
      boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
    }
  };

const offersDataFr = [
  {
    thumbImage: imgOmra1,
    title: 'Omra Septembre 2025',
    dates: 'Du 02/09 au 16/09/25',
    airline: 'Saudi Airlines',
    duration: '15 Jours',
    price: 'À partir de 2950 CHF',
    link: 'details.html',
    tag: null,
    soon: false,
  },
  {
    thumbImage: imgOmra2,
    title: 'Omra Octobre 2025',
    dates: 'Du 02/10 au 16/10/25',
    airline: 'Saudi Airlines',
    duration: '15 Jours',
    price: 'À partir de 2950 CHF',
    link: 'details.html',
    tag: null,
    soon: false,
  },
  {
    thumbImage: imgOmra3,
    title: 'Omra Novembre 2025',
    dates: 'Du 02/11 au 16/11/25',
    airline: 'Saudi Airlines',
    duration: '15 Jours',
    price: 'À partir de 2950 CHF',
    link: 'details.html',
    tag: null,
    soon: false,
  },
  {
    thumbImage: imgOmra4,
    title: 'Omra Décembre 2025',
    dates: 'Du 02/12 au 16/12/25',
    airline: 'Saudi Airlines',
    duration: '15 Jours',
    price: 'À partir de 2950 CHF',
    link: 'details.html',
    tag: null,
    soon: false,
  },
  {
    thumbImage: imgOmra5,
    title: 'Omra Fin Décembre 2025 - Janvier 2026',
    dates: 'Du 22/12/25 au 02/01/26',
    airline: 'Saudi Airlines',
    duration: '12 Jours',
    price: 'À partir de 2750 CHF',
    link: 'details.html',
    tag: null,
    soon: false,
  }
];

const offersDataAr = [
  {
    thumbImage: imgOmra1,
    title: 'عمرة سبتمبر 2025',
    dates: 'من 02/09 إلى 16/09/25',
    airline: 'الخطوط السعودية',
    duration: '15 يومًا',
    price: 'ابتداءً من 2950 فرنك',
    link: 'details.html',
    tag: null,
    soon: false,
  },
  {
    thumbImage: imgOmra2,
    title: 'عمرة أكتوبر 2025',
    dates: 'من 02/10 إلى 16/10/25',
    airline: 'الخطوط السعودية',
    duration: '15 يومًا',
    price: 'ابتداءً من 2950 فرنك',
    link: 'details.html',
    tag: null,
    soon: false,
  },
  {
    thumbImage: imgOmra3,
    title: 'عمرة نوفمبر 2025',
    dates: 'من 02/11 إلى 16/11/25',
    airline: 'الخطوط السعودية',
    duration: '15 يومًا',
    price: 'ابتداءً من 2950 فرنك',
    link: 'details.html',
    tag: null,
    soon: false,
  },
  {
    thumbImage: imgOmra4,
    title: 'عمرة ديسمبر 2025',
    dates: '16/12/25',
    airline: 'الخطوط السعودية',
    duration: '15 يومًا',
    price: 'ابتداءً من 2950 فرنك',
    link: 'details.html',
    tag: null,
    soon: false,
  },
  {
    thumbImage: imgOmra5,
    title: 'عمرة نهاية ديسمبر 2025 - يناير 2026',
    dates: 'من 22/12/25 إلى 02/01/26',
    airline: 'الخطوط السعودية',
    duration: '12 يومًا',
    price: 'ابتداءً من 2750 فرنك',
    link: 'details.html',
    tag: null,
    soon: false,
  }
];

const offers = language === 'ar' ? offersDataAr : offersDataFr;


  return (
    <section className="bg-gradient-to-r from-blue-50 via-green-100 to-blue-50" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <div className="relative h-[500px] overflow-hidden">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="absolute inset-0 h-full"
        >
          <img
            className="w-full h-full object-cover"
            src={imgOmraFévrier2025}
            alt={language === 'fr' ? "Omra Background" : "خلفية العمرة"}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-80"></div>
        </motion.div>
        
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={textAnimation}
          className="relative h-full flex flex-col items-center justify-center px-4 text-center"
        >
          <h2 className="text-white text-5xl md:text-6xl font-extrabold mb-4 tracking-wide">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-green-300 to-green-500">
              {content[language].pageTitle}
            </span>
          </h2>
          <div className="w-32 h-2 bg-green-400 rounded-full mb-6"></div>
          <p className="text-gray-200 text-xl max-w-2xl">
            {language === 'fr' 
              ? "Découvrez nos offres exclusives pour votre pèlerinage"
              : "اكتشف عروضنا الحصرية لحجك"}
          </p>
        </motion.div>
      </div>

      <div className="container mx-auto px-4 py-16">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={textAnimation}
          className="mb-12 text-center max-w-4xl mx-auto"
        >
          <p className="text-lg text-gray-700 mb-4 leading-relaxed">
            {content[language].description1}
          </p>
          <p className="text-lg text-gray-700 mb-4 leading-relaxed">
            {content[language].description2}
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            {content[language].description3}
          </p>
        </motion.div>

        <motion.h3
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={textAnimation}
          className="text-4xl font-bold text-center mb-12 relative"
        >
          <span className="relative z-10 px-4 bg-gradient-to-r from-green-500 to-green-600 bg-clip-text text-transparent">
            {content[language].offersTitle}
          </span>
          <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-32 h-1 bg-gradient-to-r from-green-400 to-blue-400 rounded-full"></span>
        </motion.h3>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {offers.map((offer, index) => (
            <motion.div
              key={index}
              initial="hidden"
              whileInView="visible"
              whileHover="hover"
              viewport={{ once: true, margin: "0px 0px -100px 0px" }}
              variants={cardAnimation}
              className="h-full"
            >
              <div className="h-full">
                <OfferCard 
                  offer={offer} 
                  language={language}
                  className="h-full transform transition-all duration-300 hover:z-10"
                />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Omra2025;